import { NextRequest, NextResponse } from 'next/server';
import { logger } from '@/lib/logger';
import { createCSRFEndpoint } from '@/lib/csrf';
import { createClient } from '@/lib/supabase/server';
import { HTTP_STATUS_INTERNAL_SERVER_ERROR } from '@/lib/constants';

/**
 * CSRF Token Endpoint
 * Generates and returns a CSRF token for authenticated users
 * This should be called after successful authentication
 */
export async function GET(request: NextRequest) {
  try {
    // Check if user is authenticated
    const supabase = await createClient();
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      return NextResponse.json({ error: 'Unauthorized' }, { status: 401 });
    }
    
    // Create and return CSRF token
    return createCSRFEndpoint(request);
  } catch (error) {
    logger.error('CSRF token generation error:', error);
    return NextResponse.json({ error: 'Internal server error' }, { status: HTTP_STATUS_INTERNAL_SERVER_ERROR });
  }
}